import Vue from 'vue'
import Router from 'vue-router'
import store from '@/services/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base:
    process.env.NODE_ENV === 'production'
      ? '/workshop/'
      : process.env.NODE_ENV === 'test'
      ? '/worktest/'
      : '/',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: async () => await import('../views/Login.vue'),
    },
    {
      path: '/settings',
      name: 'Settings',
      component: async () => await import('../views/Settings.vue'),
    },
    {
      path: '/grouplogin',
      name: 'GroupLogin',
      component: async () => await import('../views/GroupLogin.vue'),
    },
    {
      path: '/doclist',
      name: 'DocList',
      component: async () => await import('../views/DocList.vue'),
      meta: {
        requireLogin: true,
      },
    },
    {
      path: '/doczn/:id',
      name: 'DocZN',
      component: async () => await import('@/views/DocZN.vue'),
      meta: {
        requireLogin: true,
      },
    },
  ],
})

router.beforeEach((to, from, next) => {
  let userData = {}

  if (
    !store.state.userData.token &&
    to.path !== '/' &&
    to.path !== '/grouplogin'
  ) {
    let UserDataDate = undefined
    try {
      UserDataDate = localStorage.UserDataDate
      UserDataDate =
        UserDataDate && !isNaN(Number(UserDataDate))
          ? Number(UserDataDate) + 2 * 60 * 60 * 100
          : 0
    } catch (error) {
      console.error('UserDataDateЕrror: ', error)
      UserDataDate = undefined
    }
    let date = new Date(Date.now())
    date = date.getTime()
    if (UserDataDate && UserDataDate >= date) {
      userData.status = decodeURIComponent(localStorage.UserDataStatus)
      userData.statusDescription = decodeURIComponent(
        localStorage.UserDataStatusDescription
      )
      userData.token = decodeURIComponent(localStorage.UserDataToken)
      userData.workAreaAddress = decodeURIComponent(
        localStorage.workAreaAddress
      )
      userData.doNotLimitWorkAreaAddress = decodeURIComponent(
        localStorage.UserDataDoNotLimitWorkAreaAddress
      )
      userData.userId = decodeURIComponent(localStorage.UserDataUserId)
      userData.userName = decodeURIComponent(localStorage.UserDataUserName)
      store.commit('updateUserData', userData)
      store.dispatch('initApp')
      store.commit('fetchProducts', JSON.parse(localStorage.products))
      store.commit('updateServerAddress', localStorage.serverAddress)
    }
  } else {
    userData = store.state.userData
  }

  if (to.meta.requireLogin && !userData.token) {
    console.error("can't get the token", userData, to.meta)
    next('/')
  } else {
    next()
  }
})

export default router
